<script lang="ts">
const maxItems = 11
</script>
<script setup lang="ts">
import { Property } from "~/classes/entity"
import { InterfaceSelection } from "~/classes/entity/InterfaceSelection"
import { InterfaceFile } from "~/classes/file/InterfaceFile"
import { sendFolderListRequests } from "~/classes/handlers/file/list"

// TODO: only request a subset of items, only the top / first N (N+1 to show a "see more")

const props = defineProps({
  file: null
})
const { addInterfaceEventListener, removeInterfaceEventListenerByRequestId } = useEvents()
const { navigateToFile } = useNavigation()
const { downloadFiles } = useJobs()
const { peekFiles } = usePeek()
const siblings = ref<InterfaceFile[]>([]) as Ref<InterfaceFile[]>
const priorRequestId = ref<string>()
 // retrieve one more than 10 for a "show all"

function sendParentListRequest() {
  const parentId = props.file?.inferredParentId()
  if (!parentId)
    throw new Error("Cannot list file's siblings without a parent")

  // remove the previous listener, if any
  if (priorRequestId.value)
    removeInterfaceEventListenerByRequestId("folderListPageResponse", priorRequestId.value)

  const requestId = generateWorkerRequestId()
  const request: FolderListRequestDatagram = {
    requestId,
    folder: InterfaceFile.blank(parentId).inner(),
    selection: InterfaceSelection.selectedProperties([
      Property.FILE_NAME,
      Property.FILE_PARENT_ID,
      Property.THUMBNAIL_SET,
      Property.FILE_MIME_TYPE,
    ]).inner(),
    pathSelection: InterfaceSelection.minimumPathSelection().inner(),
    pageSize: maxItems, // only need top 11,
    // TODO: take top-n only. Retrieve items by property?
    sort: Property.FILE_MODIFIED_AT,
    desc: true,
    offline: false,
  }
  addInterfaceEventListener("folderListPageResponse", onParentListResponse, { requestId })
  priorRequestId.value = requestId

  sendFolderListRequests([request])
}

function onParentListResponse(response: FolderListPageResponseDatagram) {
  const { notifyDatagramError } = useAlerts()

  console.debug("Path context menu received a folder list response", response)

  if (response.error || response.files === undefined)
    return notifyDatagramError(response.error!, "Error occurred listing files")

  siblings.value = response.files.map(f => new InterfaceFile(f)).filter(f => f.fileId !== props.file.fileId)
}

onMounted(() => {
  sendParentListRequest()
})
onUnmounted(() => {
  if (priorRequestId.value)
    removeInterfaceEventListenerByRequestId("folderListPageResponse", priorRequestId.value)
})
</script>

<template>
  <template v-if="siblings.length">
    <menu-section>
      <dropdown-file-item
        v-for="sibling in siblings.slice(0, 10)"
        :key="sibling.fileId"
        :file="sibling"
        @click="navigateToFile(sibling)"
      />
    </menu-section>
    <menu-separator />
  </template>
  <menu-section>
    <dropdown-item shortcut="␣" @click="peekFiles([file], 'other')">
      Quick View
    </dropdown-item>
    <dropdown-item>
      Open in Desktop (TODO)
    </dropdown-item>
    <menu-separator />
    <dropdown-item>
      Add to Pinned (TODO)
    </dropdown-item>
    <menu-separator />
    <dropdown-item>
      Cut
    </dropdown-item>
    <dropdown-item>
      Copy
    </dropdown-item>
    <dropdown-item @click="downloadFiles({ [file.fileId]: file })">
      Download
    </dropdown-item>
  </menu-section>
  <menu-separator />
  <menu-section>
    <dropdown-file-status :file />
  </menu-section>
</template>
